const input = document.querySelector(".filterable-search-input");
const button = document.querySelector(".filterable-search-button");

if (input && button) {
  // Disable 'apply' button if input is empty
  const checkInputValue = () => {
    button.disabled = input.value === "" ? "disabled" : null;
  };

  checkInputValue();

  input.addEventListener("input", checkInputValue);
}
